
  import {Component, Vue} from 'vue-property-decorator';
  import AppDialog from '@/modules/Popup/components/AppDialog.vue';
  import {IAppState} from "@/interfaces/app-state.interface";
  import PhoneInput from "@/components/PhoneInput.vue";
  import {httpResource} from "@/resources/http.resource";

  @Component({
    components: {
      PhoneInput,
      AppDialog,
    },
  })
  export default class CantExitPopup extends Vue {
    $refs: any;
    currentPopup = { blockName: 'payment', dialogName: 'cantExitPopup' };
    formModel = {
      carNumber: '',
      phone: '',
      parkName: '',
    }
    formRules = {
      carNumber: [{
        validator: (rule, value, callback) => {
          let valid = value.length >= 7 && value.length <= 9;
          return valid ? callback() : callback(new Error('Требуется 7-9 знаков'))
        },
        required: true,
        message: 'Требуется 7-9 знаков',
        trigger: 'blur'
      }],
      phone: [{
        validator: (rule, value, callback) => {
          let valid = value.length === 18;
          return valid ? callback() : callback(new Error('Требуется 11 цифр'))
        },
        required: true, message: 'Требуется 11 цифр', trigger: 'blur'
      }],
      parkName: [{ required: true, message: ' ', trigger: 'blur' }],
    };

    get storeState(): IAppState { return this.$store.state; }
    get payloadPopup() { return this.$store.getters['dialog/getPopupPayload'](this.currentPopup); }

    async created() {
      if (this.storeState.auth.isUser) {
        if (!this.storeState.profile.profileData.phone) await this.$store.dispatch('profile/init');
        this.formModel.phone = this.storeState.profile.profileData.phone;
      }

      this.formModel.carNumber = this.payloadPopup.carNumber;
    }

    sendMessage() {
      this.$refs.cantExitForm.validate(async (valid) => {
        if (!valid) return;

        let asyncAction = async () => {
          let action = 'FeedBack';
          let params: any = {
            command: 'Add',
            question: `Не могу выехать`,
            adviceFlag: false,
            ...this.formModel,
          };
          await httpResource.httpAction({ action, params });
        };
        let success = await this.$store.dispatch('defaultResourceAction', { asyncAction });
        if (success.success) {
          this.$notify({
            title: 'Успешно',
            message: 'Спасибо, что помогаете сделать площадку лучше',
            type: 'success'
          });
          await this.onClose();
        }
      });
    }

    async onClose() {
      this.$refs.appDialog.onClose();
    }
  }
